import { Controller } from 'stimulus'
import { Modal } from 'bootstrap.native'

export default class extends Controller {
  urlValue: any
  modal: any
  static values = { url: String }

  connect() {
    this.modal = new Modal(this.element, {
      backdrop: 'static',
      keyboard: false,
    })

    this.load()

    // Force modal to be reinitialized if user clicks away before modal opens
    document.addEventListener('turbolinks:click', () => (this.modal = null), false)
  }

  disconnect() {
    if (this.modal) {
      this.modal.hide()
    }
  }

  load() {
    fetch(this.urlValue)
      .then((res) => {
        if (res.ok) {
          return res.json()
        } else {
          // Raise an error and prevent modal from opening if server responds w/ errors
          throw res
        }
      })
      .then((res_json) => {
        if(res_json.missing_activity) {
          if (!this.modal) {
            return
          }

          this.modal.show()
          window.initBSN()
        }
      })
      .catch((res) => {
        console.error(`Could not fetch missing activity - ${res.statusText}`)
        throw res
      })
  }
}
